import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppInitializeService } from './common/services/appInitialize.service';
import { ROUTES } from './app.routes';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SharedModule } from './common/utilities/shared/shared.module';
import { CookieService } from 'ngx-cookie-service';
import { ResumeApplicationComponent } from './resumeApplication/resumeApplication.component';
import { OtpResumeApplicationComponent } from './otpResumeApplication/otpResumeApplication.component';
import { FormsModule } from '@angular/forms';
import { ExistingCustomerComponent } from './existingCustomer/existingCustomer.component';
import { CircleProgressbarComponent } from './circleProgressbar/circleProgressbar.component';
import { CustomerLoginComponent } from './customerLogin/customerLogin.component';
import { OTPVerificationComponent } from './emiOtpVerification/emiOtpVerification.component';
import { MultitabFailedComponent } from './multitabFailed/multitabFailed.component';
import { OfferAddComponent } from './offerAdd/offerAdd.component';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';

import { CongratulationsComponent } from './finalModule/congratulations/congratulations.component';
import { PaymentFailedComponent } from './finalModule/paymentFailed/paymentfailed.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { RatingModule } from 'ngx-bootstrap/rating';
import { PaymentStatusComponent } from './payment-status/payment-status.component';
import { GetGoingEditComponent } from './getGoingNowEdit/getGoingNowEdit.component';
import { GetGoingComponent } from './getGoingNow/getGoingNow.component';
import { ErrorCatchingInterceptor } from './common/interceptors/error-interceptors';
import { provideSecurity } from '../lib/security';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    ResumeApplicationComponent,
    OtpResumeApplicationComponent,
    ExistingCustomerComponent,
    CircleProgressbarComponent,
    CustomerLoginComponent,
    OTPVerificationComponent,
    MultitabFailedComponent,
    OfferAddComponent,
    ToggleSwitchComponent,
    CongratulationsComponent,
    PaymentFailedComponent,
    PaymentStatusComponent,
    GetGoingEditComponent,
    GetGoingComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    // QuicklinkModule,
    RouterModule.forRoot(ROUTES, { useHash: false }), //, preloadingStrategy: QuicklinkStrategy 
    SharedModule.forRoot(),
    CarouselModule.forRoot(),
    RatingModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCatchingInterceptor,
      multi: true
    },
    AppInitializeService,
    CookieService,
    // Security Library Integration - Static Configuration in app.modules.ts
    provideSecurity({
      enableEncryption: true,
      publicKeyEndpoint: environment.serviceBaseUrls.DOMAIN01 + '/v1/crypto/init',
      expectedPublicKeyHash: '8b935bb3f35da8069d860a7f9c06d7b6514b00a9b7d437ed55f7c7f4ebbc5f30',
      encryptDecryptForEndpoints: ['*'], 
      skipEncryptDecryptForEndpoints: [
        '.json'
      ],
      enableDebugLogging: false,
      publicKeyFetchRetries: 3
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
